import axios from 'axios';
import { constant, apiEndPoints } from '../utlis/constants';
import { GetTokenLocalStorage } from './auth';

//Get Social Platfoem List
export const GetSocialPlatformList = async (userTeamId) => {
    const resp = await axios.get(`${constant.BASE_URL + apiEndPoints.post_platform}?team_id=${userTeamId}`, {
        'headers': {
            'Authorization': 'Bearer ' + GetTokenLocalStorage()
        }
    }

    );
    return resp
}

